import { render, staticRenderFns } from "./ProspectsFilter.vue?vue&type=template&id=68cbe015&"
import script from "./ProspectsFilter.vue?vue&type=script&lang=js&"
export * from "./ProspectsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports